import React, { useState, useEffect, useContext } from 'react';
import { ProductModalContext } from '../../ProductModalContext';
import { AddToWishlistContext } from '../../../../add-to-wishlist/AddToWishlistContext';
import I18NextContext from '../../../../../ui/i18next-context/I18NextContext'
import { AddToWishlistClicked } from '../../../../../../utils/Analytics';
import { constructUrl } from '../../../../../../utils/UrlConstructor';
import { AppContext } from '../../../../../../AppContext';

const wishlistIcon = 'https://cdn.obsess-vr.com/Ferragamo_icon_heart.svg';
const wishlistIconSelected = 'https://cdn.obsess-vr.com/ferragamo/heart-black.svg';

const ProductWishlistButton = ({ sku, title, price, downsizedThumbnail, sizeDropdownEnabled }) => {
    const { variantSize, variantColor, productVariantMap, currQty } = useContext(ProductModalContext)
    const { addToWishlist, removeFromWishlist, wishList, pricePrefix } = useContext(AddToWishlistContext);
    const [isInWishlist, setIsInWishlist] = useState(false);
    const [firstSeenInWishlistButton, setFirstSeenInWishlistButton] = useState(false);
    const { currentLanguage } = useContext(I18NextContext);
    const { currentSceneName } = useContext(AppContext);
    // Commenting out to fix white screen on related product with sizes clicked
    // const variantSKU = Object.keys(productVariantMap.features_map).length > 0 ? productVariantMap.features_map[variantColor][variantSize] : '';
    const productSKU = sku;

    useEffect(() => {
        if (wishList.find(item => item.SKU === sku)) {
            setIsInWishlist(true);
        } else {
            setIsInWishlist(false);
        }
    }, [wishList, productSKU])

    const handleOnClick = () => {
        // addToCart is only active when variantSize and variantColor are set
        if (sizeDropdownEnabled && !variantSize && !variantColor) {
            return;
        }


        const variantName = productVariantMap.siblings && productVariantMap.siblings[sku].name;

        const productName = variantName ? variantName : title;

        const pdpURL = `${constructUrl(productVariantMap.url)}?utm_source=houseofgift&utm_medium=${currentLanguage}&utm_campaign=holiday21&utm_content${currentSceneName}_wishlistemail`;

        if (isInWishlist) {
            removeFromWishlist(sku)
        } else {
            addToWishlist({
                SKU: sku,
                TITLE: productName,
                PRICE: price,
                QTY: currQty,
                PRICE_CURRENCY: pricePrefix,
                PDP_URL: pdpURL,
                DOWNSIZED_THUMBNAIL: downsizedThumbnail,
                PRODUCT_THUMBNAIL: downsizedThumbnail,
                SIZE: variantSize,
                URL: pdpURL
            });
            AddToWishlistClicked(sku, productName)
            setFirstSeenInWishlistButton(true);
        }
    }

    return (
        <div onClick={handleOnClick} className="wishlist-icon"><img src={isInWishlist ? wishlistIconSelected : wishlistIcon} /></div>
    );
}

export default ProductWishlistButton;
